import { render, staticRenderFns } from "./EducationForm.vue?vue&type=template&id=2411ea8c&scoped=true"
import script from "./EducationForm.vue?vue&type=script&lang=js"
export * from "./EducationForm.vue?vue&type=script&lang=js"
import style0 from "./EducationForm.vue?vue&type=style&index=0&id=2411ea8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2411ea8c",
  null
  
)

export default component.exports